import { ReactNode } from 'react'

import { Tag as BaseTag, TTagVariant } from 'partner360/components/tag'

import { TRANSLATION_KEYS } from '../../configs/translations'
import { TQualityBand } from '../../models'

interface ITagProps {
  variant?: TQualityBand
  translation?: string | ReactNode
  shortView?: boolean
}

const QUALITY_BAND_TAG_VARIANTS: Record<TQualityBand, TTagVariant> = {
  Low: 'danger',
  Moderate: 'warning',
  High: 'success',
}

export const Tag = ({ variant, translation, shortView }: ITagProps) => {
  const content = translation ?? (variant ? TRANSLATION_KEYS.tag[variant] : '')

  return (
    <BaseTag
      variant={variant ? QUALITY_BAND_TAG_VARIANTS[variant] : undefined}
      translation={content}
      shortView={shortView}
    />
  )
}
